import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { t } from '../../../../../locales';
import { resolveLocalizedText, isApp } from '../../../../../utils';
import {
  getPoPartnerServiecs,
  getCwpPartnerServiecs,
  isCWP,
  getProfileFeatures,
  getNumOfCwpPartnerServiecs,
  getNumOfPoPartnerServiecs,
  getPartnerSeeAllBtnUrl,
} from '../../../selectors/serviceSelectors';
import { EmmaPartnerService } from '../../../types/EmmaPartnerService';
import { ServiceButton } from '../PartnerServiceButton';
import './styles.scss';
import _ from 'lodash';
import {
  pushHaveReadNewFeature,
  pushHaveReadNewFeatureSingle,
  pushMyPrivilegesRedDot,
} from '../../../../../actions/sideBarItemActions';
import { goto } from '../../../../../actions/historyActions';
import { getHaveReadNewFeatures } from '../../../../../selectors/sideBarItemSelectors';
import { openDisclaimer } from '../../../../../modules/emma-common/actions';
import { getLanguage } from '../../../../../selectors/userSelectors';
import { NewFeaturepiRes } from '../../../../../types/sideBarItemTypes';
import { getDefaultRedDotMaxCount } from '../../../../../selectors/configSelectors';
import { EMMA_MY_PRIVILEGES } from '../../../../../constants/constants';
import { getBetterMeRedDotMaxCount } from '../../../../../selectors/sideBarItemSelectors';
import { select } from '../../../../../stores';
import { getToken } from '../../../../../selectors/authSelectors';
import { getValidToken } from '../../../../../utils/index';
import { iconAction } from '../../../actions';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../../utils/generalGaEventAnalytics';

const PartnerServicesLayout: any = (props: {
  partnerServices?: Array<EmmaPartnerService>;
  profileFeatures?: Array<string>;
  iconNum?: number;
  isCWP?: boolean;
  haveReadNewFeatures?: Array<NewFeaturepiRes>;
  onClickPartnerService: (service: EmmaPartnerService) => void;
  onClickToGatc: () => void;
  isNewFeatureDot: (id: string) => boolean;
  defaultRedDotMaxCount: number;
  onClickSeeAll: (id: string, clickCount: number) => void;
  redDotMaxCount: number;
  partnerServicesSeeAllBtnUrl: string;
}) => {
  const {
    isCWP,
    partnerServices,
    profileFeatures,
    iconNum,
    haveReadNewFeatures,
    onClickPartnerService,
    defaultRedDotMaxCount,
    onClickSeeAll,
    redDotMaxCount,
    partnerServicesSeeAllBtnUrl,
  } = props;
  if (!partnerServices) {
    return null;
  }

  let sortedPartnerServices: Array<any> = [];
  if (profileFeatures) {
    // Filter partner service by feature list
    const filteredPartnerServices = partnerServices.filter((item) => {
      return profileFeatures.includes(item.id);
    });

    // Sort partner service by feature list
    for (let i = 0; i < profileFeatures.length; i++) {
      if (
        _.find(filteredPartnerServices, function (o) {
          return o.id === profileFeatures[i];
        })
      ) {
        sortedPartnerServices.push(
          _.find(filteredPartnerServices, function (o) {
            return o.id === profileFeatures[i];
          }),
        );
      }
    }
  } else {
    sortedPartnerServices = [];
  }

  // filter by root
  const rootPartnerService = sortedPartnerServices.filter(
    (service) => service.visible && service.groupIds.includes('root'),
  );

  // set myprivileges show all start
  const isShowMyPrivilegesAll =
    iconNum && rootPartnerService.length > iconNum ? true : false;

  const onClickToGatc = (service: any) => {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    try {
      //ga#25 (MP5 / DAY11)
      tcWindow.dataLayer.push({
        event: 'partnerClicks',
        icon: service.label[getLanguage()],
        screenName: getGaPagePath(),
        userId: aToken,
      });
      //ga#25 (MP5 / DAY11)
      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.partnerClicks(tcWindow, {
      //     icon: service.label[getLanguage()],
      //     screenName: getGaPagePath(),
      //     AXAID: aToken,
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  };

  const isNewFeatureDot = (id: string, redDotMaxCount?: number) => {
    const featureRedDotMaxCount = redDotMaxCount
      ? redDotMaxCount
      : defaultRedDotMaxCount;
    const NewFeaturesResult = _.find(
      haveReadNewFeatures,
      (item: { id: string }) => item.id === id,
    );
    const clickCount = NewFeaturesResult ? NewFeaturesResult['clickCount'] : 0;
    const isInNewFeatureDot = clickCount < featureRedDotMaxCount ? true : false;
    return isInNewFeatureDot;
  };

  return (
    <div className="partner-service">
      <div className="partner-service__header">
        <div
          className="partner-service__title"
          dangerouslySetInnerHTML={{
            __html: memoSanitize(t('HOMEPAGE_PARTNER_SERVICE')),
          }}
        />
        <div className="partner-service__toggle-wrapper">
          {isShowMyPrivilegesAll && (
            <div className="partner-service__toggle-btn">
              <span className="partner-service__toggle-label--desktop">
                <a
                  onClick={() => {
                    onClickSeeAll(EMMA_MY_PRIVILEGES, redDotMaxCount);
                    goto(partnerServicesSeeAllBtnUrl, t('HOME_LABEL'));
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  {t('HOMEPAGE_MARKETPLACE_SEE_ALL_SERVICE')}
                </a>
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="partner-service__button-wrapper">
        {rootPartnerService.map((service: EmmaPartnerService, index) => {
          if ((iconNum && index < iconNum) || !iconNum) {
            const enableNewFeatureDot =
              service.id &&
              service.enableNewFeatureDot &&
              isNewFeatureDot(service.id, service.redDotMaxCount)
                ? true
                : false;
            let isGroupId = false;
            sortedPartnerServices
              .map((ps) => ps.groupIds)
              .map((groupArray: any) => {
                if (groupArray.includes(service.id)) {
                  isGroupId = true;
                  return;
                }
              });
            if (isGroupId) {
              // Redirect to EHub page for those item which is a group
              return service.icon && service.icon.includes('lock') ? (
                <Link
                  key={service.id}
                  to="#lockModal"
                  onClick={() => {
                    onClickToGatc(service);
                    onClickPartnerService(service);
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  <div className="inline-button-wrapper">
                    <ServiceButton
                      {...service}
                      key={service.id}
                      enableNewFeatureDot={enableNewFeatureDot}
                    />
                  </div>
                </Link>
              ) : (
                <div className="inline-button-wrapper" key={service.id}>
                  <a
                    onClick={() => {
                      onClickToGatc(service);
                      onClickPartnerService(service);
                      goto(`emma-e-hub/card-list?ehub_id=${service.id}`);
                    }}
                    data-enable-ga
                    data-ga-type="button"
                  >
                    <ServiceButton
                      {...service}
                      key={service.id}
                      enableNewFeatureDot={enableNewFeatureDot}
                    />
                  </a>
                </div>
              );
            } else {
              // Button contain disclaimer dialog
              if (
                service.deepLink &&
                service.deepLink.query &&
                service.deepLink.query.disclaimer
              ) {
                const uniqueKey: string =
                  service?.deepLink?.query?.disclaimer || '';
                return service.icon && service.icon.includes('lock') ? (
                  <Link
                    key={service.id}
                    to="#lockModal"
                    onClick={() => {
                      onClickToGatc(service);
                      onClickPartnerService(service);
                    }}
                    data-enable-ga
                    data-ga-type="button"
                  >
                    <div className="inline-button-wrapper" key={uniqueKey}>
                      <ServiceButton
                        key={uniqueKey}
                        {...service}
                        enableNewFeatureDot={enableNewFeatureDot}
                      />
                    </div>
                  </Link>
                ) : (
                  <div className="inline-button-wrapper" key={uniqueKey}>
                    <a
                      key={uniqueKey}
                      onClick={() => {
                        onClickToGatc(service);
                        onClickPartnerService(service);
                      }}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      <ServiceButton
                        key={uniqueKey}
                        {...service}
                        enableNewFeatureDot={enableNewFeatureDot}
                      />
                    </a>
                  </div>
                );
              } else if (
                service.deepLink &&
                service.deepLink.query &&
                service.deepLink.query.url
              ) {
                // Button without disclaimer dialog
                const uniqueKey: string = service.id;
                const url: string = resolveLocalizedText(
                  service.deepLink.query.url || '',
                );
                const host: string = service.deepLink.host;

                // Remove this when the oxford VR image is ready
                if (uniqueKey === 'oxfordvr') {
                  service.icon = 'images/oxford-vr.png';
                }

                return host === 'emma-common' ? (
                  <div className="inline-button-wrapper" key={uniqueKey}>
                    <a
                      onClick={() => {
                        onClickToGatc(service);
                        onClickPartnerService(service);
                        goto(url);
                      }}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      <ServiceButton
                        key={uniqueKey}
                        {...service}
                        enableNewFeatureDot={enableNewFeatureDot}
                      />
                    </a>
                  </div>
                ) : (
                  <div className="inline-button-wrapper" key={uniqueKey}>
                    <a
                      href={url}
                      target="_blank"
                      onClick={() => {
                        onClickToGatc(service);
                        onClickPartnerService(service);
                      }}
                      data-enable-ga
                      data-ga-type="button"
                      rel="noreferrer"
                    >
                      <ServiceButton
                        key={uniqueKey}
                        {...service}
                        enableNewFeatureDot={enableNewFeatureDot}
                      />
                    </a>
                  </div>
                );
              } else {
                const uniqueKey: string = service?.action?.name || '';
                return (
                  <div className="inline-button-wrapper" key={uniqueKey}>
                    <a
                      onClick={() => {
                        onClickToGatc(service);
                        onClickPartnerService(service);
                      }}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      <ServiceButton
                        key={uniqueKey}
                        {...service}
                        enableNewFeatureDot={enableNewFeatureDot}
                      />
                    </a>
                  </div>
                );
              }
            }
          }
        })}
        <div className="partner-service__more">
          <span>{t('HOMEPAGE_PARTNER_SERVICE_MORE')}</span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  const haveReadNewFeature = getHaveReadNewFeatures(state);
  return {
    partnerServices: isCWP(state)
      ? getCwpPartnerServiecs(state)
      : getPoPartnerServiecs(state),
    partnerServicesSeeAllBtnUrl: getPartnerSeeAllBtnUrl(state),
    iconNum: isCWP(state)
      ? getNumOfCwpPartnerServiecs(state)
      : getNumOfPoPartnerServiecs(state),
    profileFeatures: (getProfileFeatures(state) || []).slice(),
    haveReadNewFeatures: haveReadNewFeature
      ? haveReadNewFeature.features
      : undefined,
    isCWP: isCWP(state),
    defaultRedDotMaxCount: getDefaultRedDotMaxCount(state),
    redDotMaxCount: getBetterMeRedDotMaxCount(state),
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onClickPartnerService: (service: EmmaPartnerService) => {
    if (service.enableNewFeatureDot) {
      dispatch(
        pushHaveReadNewFeatureSingle(service.id, 1, service.redDotMaxCount),
      );
    }
    if (service && service.action) {
      dispatch(iconAction(service.action.name, service.action.payload));
    } else if (
      service &&
      service.deepLink &&
      service.deepLink.query &&
      service.deepLink.query.disclaimer
    ) {
      const disclaimer: string = service.deepLink.query.disclaimer || '';
      dispatch(openDisclaimer(disclaimer));
    }
  },
  onClickSeeAll: (id: string, clickCount: number) => {
    dispatch(pushHaveReadNewFeature(id, clickCount));
    dispatch(pushMyPrivilegesRedDot());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PartnerServicesLayout);
